import React from 'react'
import styled from 'styled-components'

const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #eeeeee;
  border: 1px solid #e0e0e0;
  padding: 16px;
  overflow-y: scroll;
  height: 400px;
`

const Timeline = (props) => {
  const { children } = props

  return (
    <TimelineContainer>
      {children}
    </TimelineContainer>
  )
}

export default Timeline